import StateButtonComponent from "@baseUI/component/button/StateButtonComponent";

export default class StateOneButtonComponent extends StateButtonComponent {

  constructor(stateTextures) {
    super(stateTextures)
    this.currentState = 1
  }

  checkForState() {
    this.currentState = 0
    this.button.gotoAndStop(this.currentState)
  }

}